<template>
  <div class="portal">
    <div class="white-background">
      <el-image
        class="banner mobile"
        fit="cover"
        :src="require('@/assets/images/gdqg/banner.png')"
      ></el-image>
      <div class="container row">
        <el-row :gutter="40">
          <el-col :sm="24">
            <div class="left-block card-shadow imgBox">
              <h1>
                <span class="icon"></span>最新云端思政资源
                <el-link
                  class="view-more-btn"
                  type="danger"
                  :underline="false"
                  @click="viewMoreNews(1916)"
                  >查看更多<i
                    class="iconfont icongengduo1"
                    style="font-size: 12px"
                  ></i
                ></el-link>
              </h1>
              <div class="infoBox resoureBox">
                <el-row :gutter="40" v-if="bigNews.title">
                  <el-col :sm="12" class="firstBox">
                    <div style="overflow: hidden; position: relative">
                      <el-image
                        class="news-image"
                        fit="cover"
                        :src="getFirstPic(bigNews.content)"
                        @click="viewNews(bigNews)"
                      >
                        <div slot="error" class="default-img">
                          <i class="iconfont iconjiaocaizhanwei"></i>
                        </div>
                      </el-image>
                      <div class="bgBox">
                        {{ bigNews.title }}
                      </div>
                      <div class="tilBox">
                        {{ replaceTag(bigNews.content) }}
                      </div>
                    </div>
                  </el-col>
                  <el-col
                    :sm="12"
                    v-for="(item, index) in news"
                    :key="index"
                    style="margin-top: -20px"
                  >
                    <div
                      class="news-item can-click"
                      :class="{ first: index === 0 }"
                      @click="viewNews(item)"
                    >
                      <el-image
                        class="cover"
                        fit="cover"
                        :src="getFirstPic(item.content)"
                      >
                        <div slot="error" class="default-img">
                          <i class="iconfont iconjiaocaizhanwei"></i>
                        </div>
                      </el-image>
                      <div class="news-info">
                        <div class="name">{{ item.title }}</div>
                        <div class="time">
                          {{ timeFormat(item.modifyTime) }}
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="container row">
        <el-row :gutter="40">
          <el-col :sm="12">
            <div class="right-block card-shadow">
              <h1>
                <span class="icon"></span>教学比赛视频轮播
                <el-link
                  class="view-more-btn"
                  type="danger"
                  :underline="false"
                  @click="viewMoreNews(1918)"
                  >查看更多<i
                    class="iconfont icongengduo1"
                    style="font-size: 12px"
                  ></i
                ></el-link>
              </h1>
              <el-row :gutter="24" style="margin: 0px">
                <el-carousel :interval="4000" type="card" height="203px">
                  <el-carousel-item
                    v-for="(item, index) in courses2"
                    :key="index"
                  >
                    <div class="activity-item" @click="viewNews(item)">
                      <el-image
                        class="cover"
                        fit="cover"
                        :src="getVideoPic(item.content)"
                      ></el-image>
                      <div class="name">{{ item.title }}</div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </el-row>
            </div>
          </el-col>
          <el-col :sm="12">
            <div class="right-block card-shadow showWork">
              <h1>
                <span class="icon"></span>学生研练作品展示
                <el-link
                  class="view-more-btn"
                  type="danger"
                  :underline="false"
                  @click="viewMoreNews(1919)"
                  >查看更多<i
                    class="iconfont icongengduo1"
                    style="font-size: 12px"
                  ></i
                ></el-link>
              </h1>
              <div class="infoBox pc">
                <el-row class="news-list" :gutter="40">
                  <el-col
                    :sm="12"
                    :xs="12"
                    v-for="(item, index) in redResources"
                    :key="index"
                    class="news-list-item"
                  >
                    <div
                      class="news-item1 can-click"
                      :class="{ first: index === 0, second: index === 1 }"
                      @click="viewNews(item, 0)"
                    >
                      <el-image
                        class="cover"
                        fit="cover"
                        :src="getUnkownPic(item.content)"
                      >
                        <div slot="error" class="default-img">
                          <i class="iconfont iconjiaocaizhanwei"></i>
                        </div>
                      </el-image>
                      <div class="news-info">
                        <div class="name">{{ item.title }}</div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="mobile">
                <el-row class="news-list" :gutter="40">
                  <div style="width: 600px; min-width: 100vw">
                    <el-col
                      :xs="12"
                      class="news-list-item"
                      style="margin-left: 20px; margin-right: 20px"
                    >
                      <div
                        v-for="(item, index) in redResources.slice(0, 4)"
                        :key="index"
                      >
                        <div
                          class="news-item1 can-click"
                          :class="{ first: index === 0, second: index === 1 }"
                          @click="viewNews(item, 0)"
                        >
                          <el-image
                            class="cover"
                            fit="cover"
                            :src="getFirstPic(item.content)"
                          >
                            <div slot="error" class="default-img">
                              <i class="iconfont iconjiaocaizhanwei"></i>
                            </div>
                          </el-image>
                          <div class="news-info">
                            <div class="name">{{ item.title }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col
                      :xs="12"
                      class="news-list-item"
                      style="margin-right: 20px"
                    >
                      <div
                        v-for="(item, index) in redResources.slice(
                          redResources.length - 4,
                          redResources.length
                        )"
                        :key="index"
                      >
                        <div
                          class="news-item1 can-click"
                          :class="{ first: index === 0, second: index === 1 }"
                          @click="viewNews(item, 0)"
                        >
                          <el-image
                            class="cover"
                            fit="cover"
                            :src="getFirstPic(item.content)"
                          >
                            <div slot="error" class="default-img">
                              <i class="iconfont iconjiaocaizhanwei"></i>
                            </div>
                          </el-image>
                          <div class="news-info">
                            <div class="name">{{ item.title }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="white-background">
      <div class="container row">
        <el-row :gutter="40">
          <el-col :sm="24">
            <div class="left-block card-shadow">
              <h1>
                <span class="icon"></span>学生讲思政课
                <el-link
                  class="view-more-btn"
                  type="danger"
                  :underline="false"
                  @click="viewMoreNews(1922)"
                  >查看更多<i
                    class="iconfont icongengduo1"
                    style="font-size: 12px"
                  ></i
                ></el-link>
              </h1>
              <div class="infoBox">
                <el-row class="brand-list" :gutter="20">
                  <el-col
                    :sm="6"
                    :xs="12"
                    v-for="(item, index) in brands"
                    :key="index"
                  >
                    <div
                      class="brand-item can-click hover-bigger"
                      @click="viewBrand2(item)"
                    >
                      <div class="cover-wrapper">
                        <el-image
                          class="cover"
                          fit="cover"
                          :src="getVideoPic(item.content)"
                        ></el-image>
                      </div>
                      <div class="name">{{ item.title }}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="container row last-row">
        <el-row :gutter="40">
          <el-col :sm="24">
            <div class="left-block card-shadow">
              <h1>
                <span class="icon"></span>VR资源
                <el-link
                  class="view-more-btn"
                  type="danger"
                  :underline="false"
                  @click="viewMoreNews(1923)"
                  >查看更多<i
                    class="iconfont icongengduo1"
                    style="font-size: 12px"
                  ></i
                ></el-link>
              </h1>
              <div class="infoBox">
                <el-row class="brand-list" :gutter="20">
                  <el-col
                    :sm="4"
                    :xs="12"
                    v-for="(item, index) in courses"
                    :key="index"
                  >
                    <div
                      class="brand-item can-click hover-bigger"
                      @click="viewBrand(item)"
                    >
                      <div class="cover-wrapper">
                        <el-image
                          class="cover"
                          fit="cover"
                          :src="getVideoPic(item.content)"
                        ></el-image>
                      </div>
                      <div class="name">{{ item.title }}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticles } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "portal",
  data() {
    return {
      baseUrl: process.env.VUE_APP_PUBLIC_PATH || "./",
      data: {},
      redResources: [],
      bigNews: {},
      news: [],
      news1: [],
      courses: [],
      courses2: [],
      brands: [],
    };
  },
  created() {
    getArticles({
      relationId: 3787,
      menuId: 1918,
      relationType: 1,
      ps: 10,
      pn: 1,
    })
      .then((res) => {
        // 返回数据
        this.courses2 = res.list;
      })
      .catch((err) => {
        // 异常情况
        console.log(err);
      });

    getArticles({
      relationId: 3787,
      menuId: 1916,
      relationType: 1,
      ps: 5,
      pn: 1,
    })
      .then((res) => {
        // 返回数据
        this.bigNews = res.list[0] ? res.list[0] : {};
        this.news = res.list.slice(1);
      })
      .catch((err) => {
        // 异常情况
        console.log(err);
      });
    getArticles({
      relationId: 3787,
      menuId: 1919,
      relationType: 1,
      ps: 8,
      pn: 1,
    })
      .then((res) => {
        // 返回数据
        this.redResources = res.list;
      })
      .catch((err) => {
        // 异常情况
        console.log(err);
      });
    getArticles({
      relationId: 3787,
      menuId: 1923,
      relationType: 1,
      ps: 6,
      pn: 1,
    })
      .then((res) => {
        // 返回数据
        this.courses = res.list;
      })
      .catch((err) => {
        // 异常情况
        console.log(err);
      });

    getArticles({
      relationId: 3787,
      menuId: 1922,
      relationType: 1,
      ps: 8,
      pn: 1,
    })
      .then((res) => {
        // 处理数据
        this.brands = res.list;
      })
      .catch((err) => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    viewRedResource(item) {
      window.open(item.link);
    },
    viewTjhj() {
      window.open("#/tjhj");
    },
    viewMoreNews(id) {
      this.$router.push(`./news/${id}/0?type=1`);
    },
    viewNews(item) {
      this.$router.push(`./news/1916/${item.id}?type=1`);
    },
    viewMoreCourses() {
      this.$router.push("/tjxd/courses");
    },
    viewCourse(item) {
      window.open(`#/tjxd/courseContent/${item.ocId}`);
    },
    viewCourse2(item) {
      window.open(
        `https://www.ulearning.cn/ulearning_web/web!courseDetail.do?courseID=${item.id}`
      );
    },
    viewMoreTeachers() {
      this.$router.push("./teachers");
    },
    viewTeacher(item) {
      window.open(`#/tjxd/teacherContent/${item.domain}`);
    },

    viewBrand(item) {
      this.$router.push(`./news/1922/${item.id}?type=1`);
    },
    viewBrand2(item) {
      this.$router.push(`./news/1923/${item.id}?type=1`);
    },
    getCover(url) {
      return url + "?vframe/jpg/offset/10";
    },
    replaceTag: util.replaceTag,
    getFirstPic: util.getFirstPic,
    getVideoPic: util.getVideoPic,
    getUnkownPic(url){
      if(this.getFirstPic(url)){
        return this.getFirstPic(url)
      }else{
        return this.getVideoPic(url)
      }
    },
    timeFormat(value) {
      return util.timeFormat(value, "yyyy-MM-dd");
    },
    dateFormat(value) {
      return util.timeFormat(value, "MM.dd");
    },
  },
};
</script>

<style scoped>
.showWork h1 {
  margin-bottom: 20px;
  line-height: 24px;
}
.showWork .news-list {
  margin-bottom: -3px;
}
.default-img .iconfont {
  width: 36px;
  height: 36px;
  font-size: 36px;
}
.left-block,
.right-block {
  padding: 24px 30px;
  background-color: #fff;
}
.imgBox {
  padding-bottom: 0px;
}
.right-block {
  padding-top: 22px;
  border-top: 2px solid #ff4e00;
}

.row {
  padding-top: 30px;
}
.firstBox {
  position: relative;
  margin-bottom: 20px;
}
.firstBox .bgBox {
  box-sizing: content-box;
  padding: 8px 4%;
  color: #fff;
  line-height: 24px;
  position: absolute;
  bottom: 59px;
  left: 0px;
  width: 92%;
  opacity: 0.5;
  background: #000000;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
  max-height: 50px;
}
.tilBox {
  margin-top: 18px;
  font-size: 12px;
  color: #969696;
  line-height: 21px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}
.last-row {
  padding-bottom: 80px;
}

h1 {
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 24px;
  color: #444;
}

h1 .iconfont {
  margin-top: 2px;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

h1 .icon {
  display: inline-block;
  margin-right: 12px;
  margin-top: 2px;
  width: 6px;
  height: 20px;
  vertical-align: top;
  background-image: linear-gradient(126deg, #ff8b23 0%, #e61400 100%);
}

.radius-2 {
  border-radius: 2px;
  overflow: hidden;
}

.portal .view-more-btn {
  float: right;
  font-weight: normal;
  color: #666666;
  vertical-align: top;
}

.portal .view-more-btn:hover {
  color: #ec2f08;
}

h2 {
  margin: 0;
  height: 52px;
  line-height: 26px;
  font-size: 18px;
  overflow: hidden;
}

.news-image {
  display: block;
  height: 315px;
  background-color: #eee;
  cursor: pointer;
}

.news-detail {
  margin-top: 12px;
  height: 140px;
  line-height: 28px;
  font-size: 14px;
  overflow: hidden;
}

.news-list {
  margin-top: 13px;
  margin-bottom: -24px;
}

.news-item {
  position: relative;
  padding: 20px 0;
  padding-top: 11px;
  border-top: 1px dashed #e5e5e5;
  
}
.news-item.first {
  padding-top: 20px;
}
.news-item.first,
.news-item.second {
  border-top: unset;
}

.news-item .cover {
  position: absolute;
  width: 128px;
  height: 72px;
  background-color: #eee;
}

.news-item .news-info {
  min-height: 45px;
  padding-left: 148px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}

.news-item .name {
  height: 46px;
  line-height: 23px;
  font-size: 14px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}

.news-item .time {
  margin-top: 5px;
  height: 35px;
  line-height: 30px;
  font-size: 12px;
  color: #888;
  overflow: hidden;
}

.news-item1 {
  position: relative;
  padding: 7px 0;
  /* border-top: 1px dashed #e5e5e5; */
}

.news-item1.first,
.news-item1.second {
  border-top: unset;
}

.news-item1 .cover {
  position: absolute;
  width: 80px;
  height: 45px;
  background-color: #eee;
}

.news-item1 .news-info {
  min-height: 45px;
  padding-left: 92px;
}

.news-item1 .name {
  height: 45px;
  line-height: 23px;
  font-size: 14px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}

.news-item1 .time {
  margin-top: 5px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #888;
  overflow: hidden;
}

.file-list {
  margin: -18px 0;
}

.file-item {
  height: 44px;
  padding: 18px 0;
  border-top: 1px dashed #e5e5e5;
}

.file-item.first {
  border-top: unset;
}

.file-item .time {
  float: left;
  margin-right: 16px;
  margin-top: 1px;
  width: 42px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background-color: #ff8700;
}

.file-item .name {
  max-height: 44px;
  line-height: 22px;
  font-size: 14px;
  overflow: hidden;
}

.course-item {
  border: 1px solid #e5e5e5;
}

.cover-wrapper {
  position: relative;
  padding-bottom: 56.25%;
}

.cover-wrapper .cover {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #eee;
}

.course-item .course-info {
  padding: 14px 10px 16px 10px;
}

.course-item .name {
  height: 44px;
  line-height: 22px;
  font-size: 14px;
  overflow: hidden;
}

.course-item .creator {
  margin-top: 10px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  overflow: hidden;
}

.mt40 {
  margin-top: 44px;
}

.teacher-list {
  margin: -32px 0;
}

.teacher-item {
  height: 130px;
  padding: 32px 0;
  border-top: 1px dashed #e5e5e5;
}

.teacher-item.first {
  border-top: unset;
}

.teacher-item .head {
  float: left;
  margin-right: 10px;
}

.head .cover {
  display: block;
  width: 100px;
  height: 100px;
  background-color: #eee;
}

.teacher-item .name2 {
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background-color: #ff8700;
}

.teacher-item .position {
  height: 48px;
  line-height: 24px;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
}

.teacher-item .detail {
  margin-top: 10px;
  height: 72px;
  line-height: 24px;
  font-size: 14px;
  color: #888;
  overflow: hidden;
}

.banner {
  display: block;
  height: 112px;
}

.brand-list {
  margin-top: -24px;
}

.brand-item {
  margin-top: 24px;
}

.brand-item .name {
  margin-top: 10px;
  height: 44px;
  line-height: 22px;
  font-size: 14px;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}

.brand-banner {
  margin-bottom: 17px;
  display: block;
  height: 64px;
  cursor: pointer;
}

.red-resource {
  background-image: url("~@/assets/images/tjxd/portal-red-background.png"),
    linear-gradient(
      180deg,
      rgba(253, 228, 182, 0.52) 1%,
      rgba(247, 199, 136, 0.78) 100%
    );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
}

.resource-list {
  margin-bottom: -12px;
}

.resource-item {
  margin-bottom: 12px;
  cursor: pointer;
}

.resource-item .iconfont {
  float: left;
  margin-left: 3px;
  margin-right: 10px;
  line-height: 22px;
  font-size: 12px;
  color: #ff8700;
}

.resource-item .name {
  display: table;
  height: 44px;
  line-height: 22px;
  font-size: 14px;
  color: #666;
  overflow: hidden;
  transition: all ease 0.3s;
}

.resource-item .name .name-text {
  display: table-cell;
  vertical-align: middle;
}

.resource-item:hover .name {
  color: #ec2f08;
}

.block-background {
  padding-bottom: 40px;
  background-color: #fff9f6;
  background-image: url("~@/assets/images/tjxd/portal-block.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: bottom;
}

.white-background {
  background-color: #fff9f6;
}

/* 对齐模块处理 */
@media (max-width: 1199px) {
  .mt40 {
    margin-top: 46px;
  }

  .teacher-list {
    margin: -20px 0;
  }

  .teacher-item {
    padding: 20px 0;
  }

  .resource-item.last {
    display: none;
  }

  .red-resource {
    padding-bottom: 27px;
  }
}

@media (max-width: 767px) {
  h1{
    font-size: 18px;
  }
  .icon.mobile {
    display: inline-block !important;
  }
  .infoBox {
    background-color: #fff;
    padding: 15px 12px;
  }
  .banner {
    height: 100px;
    display: block !important;
  }
  .news-image{
    height: 255px;
  }
  .row {
    margin-top: 0;
  }
  .resoureBox .el-row{
    margin-bottom: -35px;
  }
  .last-row {
    padding-bottom: 50px;
  }

  h1 {
    margin-bottom: 12px;
  }

  .radius-2 {
    margin: 10px 0;
  }

  .left-block,
  .right-block {
    padding: 12px 0;
    background-color: #f7f8fa !important;
  }

  .right-block {
    border-top: unset;
  }

  .mt40 {
    margin-top: 12px;
  }

  .news-image {
    margin-bottom: 12px;
  }

  .news-item.second {
    border-top: 1px dashed #e5e5e5;
  }
  /* .news-item:last-child{
   padding-bottom: 5px;
  } */

  .news-list {
    margin-top: 0;
  }

  .brand-banner {
    margin-bottom: 10px;
    height: 50px;
  }
  .brand-item .name {
    margin-top: 10px;
    height: 44px;
    line-height: 22px;
    font-size: 14px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
  }
  .course-item {
    position: relative;
    padding: 14px 0;
    border: unset;
    border-top: 1px solid #eee;
  }

  .course-item.first {
    border-top: unset;
  }

  .course-item .cover-wrapper {
    position: absolute;
    width: 142px;
    height: 80px;
    padding-bottom: unset;
  }

  .course-item .course-info {
    min-height: 80px;
    padding: 0 0 0 154px;
  }

  .course-item .creator {
    font-size: 12px;
    color: #666;
  }

  .red-resource {
    padding-bottom: 0;
    background: unset;
  }

  .resource-item .name {
    color: #444;
  }

  .block-background {
    padding-top: 10px;
    padding-bottom: 0;
    background: unset;
  }

  .white-background {
    background-color: #f7f8fa;
  }
  .news-list {
    white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden;
  }
  .news-list::-webkit-scrollbar {
    display: none;
  }
  .news-list-item {
    width: 270px;
    min-width: calc((100vw - 60px) / 2);
    background-color: #fff;
    padding-left: 12px !important;
    padding-right: 12px !important;
    padding-bottom: 5px;
    padding-top: 5px;
  }
}
.activity-item {
  position: relative;
  height: 100%;
}

.activity-item .cover {
  display: block;
  height: 100%;
  background-color: #eee;
}

.activity-item .name {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  line-height: 28px;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}

.is-active .activity-item .name {
  display: unset;
}
</style>
<style >
.gdqg .el-carousel__mask{
 background-color: #444 !important;
 z-index: 99;
 opacity: 0.5;
}
.right-block .el-carousel__button{
  width: 15px;
}
.right-block .is-active .el-carousel__button{
  background-color: #ec2f08;
}
</style>